export default "<div>\r\n    <router-outlet></router-outlet>\r\n\r\n</div>\r\n"